import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useEffect, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import './style.css';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import Plan from './Plan';
import defaultImage from '../../assets/images/DefaultImage.png';
import { EditEvent, getTheEvent } from '../../services/events/event';
import { useDispatch, useSelector } from 'react-redux';
import { setEventId } from '../../redux/search.slice';
import { GlobalDropDown } from '../../components/GlobalDropDown';
import { setLocalEventId } from '../../redux/search.slice';

const formatOptions = 'dd/MM/yyyy';
let event_codeValue = -1;
let event_task = '';
let description = '';
let asset = '';
let equipment = '';
let function_location = '';
let duration = 0;
let planned_start_date = new Date('');
let planned_end_date = new Date('');
let scheduled_start_date = new Date('');
let scheduled_end_date = new Date('');
let actual_start_date = new Date('');
let actual_end_date = new Date('');
let compliance_date = new Date('');
let created_date = new Date('');
let tolerance = 0;
let event_planner = '';
let event_scheduler = '';
let event_supervisor = '';
let project_managerText = '';
let eventId: number = 0;
let isFirstRender3: boolean = true;
let eventStatusDropDown: DropDownListComponent | null;
let eventType: DropDownListComponent | null;
let projectManagerDropDown: DropDownListComponent | null;
let eventDropDown: DropDownListComponent | null;
const EventManagement = () => {
  const [c_event_value, setC_EventValue] = useState<number>(-1);
  const [isRenderSec3, setIsRenderSec3] = useState<boolean>(false);
  const [projectManagerValue, setProjectManagerValue] = useState<number>();
  const [eventStatusText, setEventStatusText] = useState<string>('');
  const [eventTypeText, setEventTypeText] = useState<string>('');
  let reduxEventId = useSelector((state: any) => state.search.event_id);
  let local_event_id = useSelector((state: any) => state.search.local_event_id);
  const [eventValue, setEventValue] = useState<number>(local_event_id);
  const dispatch = useDispatch();
  useEffect(() => {
    // var eventidLocalStorage = localStorage.getItem('Event_Id') ?? '';
    // setEventValue(() => parseInt(eventidLocalStorage));

    $('.collapse-first').click(function () {
      $('.firstEM').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement').toggleClass('rotateIcon-event');
    });
    $('.collapse-second').click(function () {
      $('.second').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement2').toggleClass('rotateIcon-event');
    });
    $('.collapse-three').click(function () {
      $('.threeEM').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement3').toggleClass('rotateIcon-event');
    });
    $('.collapse-four').click(() => {
      if (event_codeValue === -1) {
        //
      }
      if (isFirstRender3) {
        setIsRenderSec3(true);
      } else {
        $('.four').toggleClass('show-content-event');
        $('#rotate-icon-eventmanagement4').toggleClass('rotateIcon-event');
      }
      isFirstRender3 = false;
    });

    return () => {
      $('.collapse-first').off('click');
      $('.collapse-second').off('click');
      $('.collapse-three').off('click');
      $('.collapse-four').off('click');
    };
  }, []);
  useEffect(() => {
    var eventidLocalStorage = localStorage.getItem('Event_Id') ?? '';
    setEventValue(() => parseInt(eventidLocalStorage));
    if (reduxEventId !== 0) {
      setInputs(reduxEventId);
    } else if (reduxEventId === 0) {
      setInputs(local_event_id);
    }
    isFirstRender3 = true;
  }, [reduxEventId]);

  const OnchangeEvent = (args: any) => {
    dispatch(setEventId(args.target.value));
    dispatch(setLocalEventId(args.target.value));

    let event_id = args.target.value;
    eventId = event_id;
    setInputs(event_id);
    setEventId(args.target.value);
  };
  const setInputs = async (eventId: any) => {
    const eventData = (await getTheEvent(eventId)).data;
    dispatch(setEventId(0));

    // eventDropDown && (eventDropDown.value = eventData?.eventId);
    actual_start_date = new Date(eventData?.actualStartDate);
    actual_end_date = new Date(eventData?.actualEndDate);
    asset = eventData?.asset;
    compliance_date = new Date(eventData?.complianceDate);
    created_date = new Date(eventData?.creationDate);
    description = eventData?.description;
    duration = eventData?.duration;
    equipment = eventData?.equipment;
    eventId = eventId;
    event_planner = eventData?.eventPlanner;
    event_scheduler = eventData?.eventScheduler;
    event_supervisor = eventData?.eventSupervisor;
    event_task = eventData?.eventTask;
    function_location = eventData?.functionLocation;
    planned_start_date = new Date(eventData?.plannedStartDate);
    planned_end_date = new Date(eventData?.plannedEndDate);
    scheduled_start_date = new Date(eventData?.scheduledStartDate);
    scheduled_end_date = new Date(eventData?.scheduledEndDate);
    // eventStatusDropDown && (eventStatusDropDown.text = eventData?.status);
    // projectManagerDropDown &&
    //   (projectManagerDropDown.value = eventData?.customNumberField1);
    // eventType && (eventType.text = eventData?.type);
    // eventStatusDropDown?.refresh();
    // projectManagerDropDown?.refresh();
    // eventType?.refresh();
    // eventDropDown?.refresh();
    if (eventData) {
      setEventTypeText(eventData?.type);
      tolerance = eventData.tolerance;
      setEventStatusText(eventData?.status);

      if (eventData.eventId !== undefined) {
        localStorage.setItem('Event_Id', eventData.eventId);
        setEventValue(() => eventData?.eventId);
      }
      setC_EventValue(eventId);
      setProjectManagerValue(eventData?.customNumberField1);
    }
  };
  const SavePoint = () => {
    if (!eventDropDown?.value) {
      Message.error('Event Code can not be empty');
      return false;
    }
    if (description === '') {
      Message.error('Description can not be empty');
      return false;
    }
    if (!eventType?.value) {
      Message.error('Type can not be empty');
      return false;
    }
    if (!eventStatusDropDown?.text) {
      Message.error('Status can not be empty');
      return false;
    }

    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      eventCode: eventDropDown.text,
      eventTask: event_task,
      description: description,
      status: eventStatusDropDown?.text,
      type: eventType?.text,
      asset: asset,
      equipment: equipment,
      functionLocation: function_location,
      duration: duration,
      plannedStartDate: planned_start_date,
      plannedEndDate: planned_end_date,
      scheduledStartDate: scheduled_start_date,
      scheduledEndDate: scheduled_end_date,
      actualStartDate: actual_start_date,
      actualEndDate: actual_end_date,
      complianceDate: compliance_date,
      tolerance: tolerance,
      eventPlanner: event_planner,
      eventScheduler: event_scheduler,
      eventSupervisor: event_supervisor,
      projectManager: project_managerText,
      customNumberField1: projectManagerDropDown?.value,
      eventId: Number(eventId),
    };
    EditEvent(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const itemProjectManagerTemplate = (args: any) => {
    var location = window.location.href;
    try {
      var imageUrl = require(`${location}static/media/people/` +
        args.image_url);
      return (
        <div className='project-manager-control-itemsImage'>
          <span className='project-mager-image'>
            <img src={imageUrl} alt='Person' />
          </span>
          <span className='col-md-9'>
            {args.firstName + ' ' + args.lastName}
          </span>
        </div>
      );
    } catch (err) {
      return (
        <div className='project-manager-control-itemsImage'>
          <span className='project-mager-image'>
            <img src={defaultImage} alt='Person' />
          </span>
          <span className='col-md-9'>
            {args.firstName + ' ' + args.lastName}
          </span>
        </div>
      );
    }
  };
  return (
    <div className=' content-EventManagement'>
      <div className='header-eventManagement-fixed'>
        <button
          style={{ marginRight: '5px', width: '90px', height: '40px' }}
          className='btn btn-primary p-3 rounded-xl'
          onClick={() => SavePoint()}
        >
          Save
        </button>
        <button
          style={{ width: '90px', height: '40px' }}
          className='btn btn-secondary p-3'
        >
          Cancel
        </button>
      </div>
      <div className='eventmanagement-sub-content'>
        <div className='collapse-parent-div'>
          <div className='collapse-sub-flex collapse-first'>
            <div className='collapse-icon-div collapse-flex'>
              <FiChevronDown
                id='rotate-icon-eventmanagement'
                className='rotateIcon-event'
                size={17}
              />
            </div>
          </div>
          <div className='firstEM'>
            <div className='col-lg-4'>
              <div className='col-lg-12'>
                <div className='row'>
                  <div className='col-lg-4'>
                    <GlobalDropDown
                      id='eventmanagement-event'
                      placeHolder='Select an event'
                      field={{ value: 'eventId', text: 'eventCode' }}
                      refDD={(s: DropDownListComponent) => (eventDropDown = s)}
                      url='events'
                      value={eventValue}
                      onChange={OnchangeEvent}
                      floatLabelType='Auto'
                      key='eventmanagement-event-key'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-4'>
                    <TextBoxComponent
                      placeholder='Asset number'
                      value={asset}
                      autocomplete='off'
                      onChange={(e: any) => {
                        asset = e.target.value;
                      }}
                      floatLabelType='Auto'
                    />
                  </div>
                  <div className='col-lg-4'>
                    <TextBoxComponent
                      placeholder='Functional Location'
                      autocomplete='off'
                      value={function_location}
                      onChange={(e: any) => {
                        function_location = e.target.value;
                      }}
                      floatLabelType='Auto'
                    />
                  </div>
                  <div className='col-lg-4'>
                    <TextBoxComponent
                      id='eventmanagement123fdgdfg'
                      placeholder='Equipment'
                      value={equipment}
                      type='search'
                      autocomplete='new-password'
                      onChange={(e: any) => {
                        equipment = e.target.value;
                      }}
                      floatLabelType='Auto'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <TextBoxComponent
                      placeholder='Event Desciption'
                      value={description}
                      autocomplete='off'
                      onChange={(e: any) => {
                        description = e.target.value;
                      }}
                      floatLabelType='Auto'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-5'>
              <div className='col-lg-4'></div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='createdDate'
                  style={{ height: 25 }}
                  placeholder='Created Date'
                  format={formatOptions}
                  value={created_date}
                  enabled={false}
                  onChange={(e: any) => {
                    created_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='scheduledStart'
                  style={{ height: 25 }}
                  placeholder='Scheduled Start'
                  format={formatOptions}
                  value={scheduled_start_date}
                  onChange={(e: any) => {
                    scheduled_start_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='plannedStart'
                  style={{ height: 25 }}
                  value={planned_start_date}
                  placeholder='Planned Start'
                  format={formatOptions}
                  onChange={(e: any) => {
                    planned_start_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='ComplianceDate'
                  style={{ height: 25 }}
                  format={formatOptions}
                  placeholder='Compliance Date'
                  value={compliance_date}
                  onChange={(e: any) => {
                    compliance_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>

              <div className='col-lg-4'>
                <DatePickerComponent
                  id='scheduledEnd'
                  style={{ height: 25 }}
                  placeholder='Scheduled End'
                  format={formatOptions}
                  value={scheduled_end_date}
                  onChange={(e: any) => {
                    scheduled_end_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='plannedEnd'
                  style={{ height: 25 }}
                  placeholder='Planned End'
                  format={formatOptions}
                  value={planned_end_date}
                  onChange={(e: any) => {
                    planned_end_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='actualStartDate'
                  style={{ height: 25 }}
                  placeholder='Actual Start'
                  format={formatOptions}
                  value={actual_start_date}
                  onChange={(e: any) => {
                    actual_start_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>
              <div className='col-lg-4'>
                <DatePickerComponent
                  id='actualDate'
                  style={{ height: 25 }}
                  format={formatOptions}
                  value={actual_end_date}
                  onChange={(e: any) => {
                    actual_end_date = e.target.value;
                  }}
                  placeholder='Actual End'
                  floatLabelType='Auto'
                />
              </div>
            </div>

            <div className='col-lg-3'>
              <div className='col-lg-6 p-0'>
                <div className='col-lg-12 px-3'>
                  <GlobalDropDown
                    id='eventmanagement-status'
                    placeHolder='Select an event status'
                    key='eventmanagement-status-key'
                    field={{ value: 'statusCode', text: 'statusCode' }}
                    refDD={(scope: DropDownListComponent) =>
                      (eventStatusDropDown = scope)
                    }
                    url='event-status'
                    value={eventStatusText}
                    floatLabelType='Auto'
                  />
                </div>
                <div className='col-lg-12 px-3'>
                  <GlobalDropDown
                    id='eventmanagement-project-manager'
                    placeHolder='Project Manager'
                    field={{ value: 'id', text: 'firstName' }}
                    key='eventmanagement-project-manager-key'
                    refDD={(scope: DropDownListComponent) =>
                      (projectManagerDropDown = scope)
                    }
                    selected={(e: any) =>
                    (project_managerText =
                      e.itemData.firstName + ' ' + e.itemData.lastName)
                    }
                    value={projectManagerValue}
                    url='event-resources'
                    floatLabelType='Auto'
                    valueTemplate={(e: any) => (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: 5,
                        }}
                      >
                        {e.firstName + ' ' + e.lastName}
                      </div>
                    )}
                    itemTemplate={itemProjectManagerTemplate.bind(this)}
                  />
                </div>
                <div className='col-lg-12 px-3'>
                  <GlobalDropDown
                    id='eventmanagement-type'
                    key='eventmanagement-type-key'
                    placeHolder='Select an event type'
                    field={{ value: 'typeCode', text: 'typeCode' }}
                    refDD={(scope: DropDownListComponent) =>
                      (eventType = scope)
                    }
                    url='event-type'
                    value={eventTypeText}
                    floatLabelType='Auto'
                  />
                </div>
              </div>
              <div className='col-lg-6'>
                {/* <div className='col-lg-12 pb-1'>
                  <span>Event Logo</span>
                </div>
                <div style={{ marginTop: 24 }}>
                  <UploaderComponent style={{ height: 25 }} />
                </div> */}
              </div>
              {/* <div className='col-md-4' style={{ padding: '10px' }}>
                    <div className='link-event'>
                      <button className='link-event-button'>
                        + Link Event
                      </button>
                    </div>
                    <div className='parent-event'>
                      <span>Parent Event:</span>
                      <div className='parent-event-code'>
                        <span>E-100300</span>
                      </div>
                    </div>
                    <div className='notes'>
                      <span>
                        Notes: if Parent Event=Event Code then do not display
                        this text box. if different then display description
                        for Parent event. Database field for parent
                        event=event_task
                      </span>
                    </div>
                  </div> */}
            </div>
          </div>
        </div>
        <div className='collapse-parent-div '>
          <div className='collapse-sub-flex collapse-four'>
            <div className='collapse-icon-div-four collapse-flex'>
              <FiChevronDown id='rotate-icon-eventmanagement4' size={17} />
            </div>
          </div>
          {isRenderSec3 ? (
            <div className='four show-content-event'>
              <div>
                <label style={{ fontSize: '18px' }}>Project Work Bench</label>
                <Plan event_id={c_event_value} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default EventManagement;
